import React, { useState } from 'react';
import { authToken } from '../../authToken';
import { API_BASE_URL } from '../../config';

const ENDPOINT_HOST = API_BASE_URL;
const ENDPOINT_REGISTERED_EVENT_TYPE = `${ENDPOINT_HOST}/registeredeventtype`;

export default function RegisteredEventsTypeAddPanel({ onClose = null }) {
  const [preferredDays, setPreferredDays] = useState('');
  const [eventType, setEventType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleCancel = () => {
    setPreferredDays('');
    setEventType('');
    setError(null);
    if (onClose) onClose();
  };

  const handleOk = async () => {
    const normalizedPreferredDays = Number.parseInt(preferredDays, 10);

    if (!eventType.trim()) {
      setError('Event type is required.');
      return;
    }

    if (Number.isNaN(normalizedPreferredDays)) {
      setError('Preferred days must be a valid integer.');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const response = await fetch(ENDPOINT_REGISTERED_EVENT_TYPE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(authToken ? { 'Authorization': authToken } : {})
        },
        body: JSON.stringify({
          preferredDays: normalizedPreferredDays,
          eventtype: eventType.trim()
        })
      });

      if (response.ok) {
        if (onClose) onClose();
      } else {
        const errorData = await response.text();
        setError(`Failed to add registered event type entry: ${errorData} (${response.status})`);
      }
    } catch (e) {
      console.error('Failed to add registered event type entry:', e);
      setError('Failed to add registered event type entry. Please check your connection.');
    } finally {
      setTimeout(() => setIsSubmitting(false), 1000);
    }
  };

  const buttonStyle = {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    minWidth: '100px'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px',
    border: '1px solid #ced4da',
    borderRadius: '8px',
    fontSize: '14px',
    backgroundColor: 'white',
    boxSizing: 'border-box'
  };

  return (
    <div
      style={{
        padding: '10px 0',
        maxWidth: '400px',
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <div>
        <h3 style={{ margin: '0 0 16px 0', textAlign: 'center' }}>
          🗂️ Add Registered Event Type
        </h3>

        {error && (
          <div
            style={{
              padding: '12px',
              backgroundColor: '#f8d7da',
              color: '#721c24',
              borderRadius: '8px',
              marginBottom: '16px',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #f5c6cb'
            }}
          >
            ⚠️ {error}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            value={eventType}
            onChange={(e) => setEventType(e.target.value)}
            placeholder="Event type"
            style={inputStyle}
          />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            inputMode="numeric"
            value={preferredDays}
            onChange={(e) => setPreferredDays(e.target.value)}
            placeholder="Preferred days"
            style={inputStyle}
          />
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          marginTop: 'auto'
        }}
      >
        <button
          onClick={handleCancel}
          disabled={isSubmitting}
          style={{
            ...buttonStyle,
            backgroundColor: '#6c757d',
            color: 'white',
            opacity: isSubmitting ? 0.6 : 1
          }}
          onMouseOver={(e) => !isSubmitting && (e.target.style.backgroundColor = '#5a6268')}
          onMouseOut={(e) => !isSubmitting && (e.target.style.backgroundColor = '#6c757d')}
        >
          Cancel
        </button>
        <button
          onClick={handleOk}
          disabled={isSubmitting}
          style={{
            ...buttonStyle,
            backgroundColor: '#f6e96b',
            color: '#333',
            opacity: isSubmitting ? 0.6 : 1
          }}
          onMouseOver={(e) => !isSubmitting && (e.target.style.backgroundColor = '#f4e456')}
          onMouseOut={(e) => !isSubmitting && (e.target.style.backgroundColor = '#f6e96b')}
        >
          {isSubmitting ? 'Adding...' : 'OK'}
        </button>
      </div>
    </div>
  );
}